import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cart-delivery-date__none-selected"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "cart-delivery-date__slot-inner" };
const _hoisted_4 = ["title"];
import { onMounted, onUnmounted, ref, watch } from 'vue';
import moment from 'moment';
import cartRepository from '../services/CartRepository';
import WeekCalendar from "@astina/paloma-common-ui/src/components/WeekCalendar.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartDeliveryDate',
    props: {
        order: {},
        visibleWeeks: {},
        maxWeeks: {}
    },
    emits: [
        'select-scheme'
    ],
    setup(__props, { emit: __emit }) {
        const CART_EVENTS = [
            'command.add_cart_items.success',
            'command.update_cart_items.success',
        ];
        const props = __props;
        const emit = __emit;
        const loading = ref(false);
        const options = ref(null);
        const deliverySlots = ref([]);
        const selectedDate = ref(null);
        const selectedDeliveryScheme = ref(null);
        const date = ref(new Date());
        const minDate = ref(new Date());
        const maxDate = ref(moment()
            .startOf('week')
            .add(props.maxWeeks ?? 4, 'weeks')
            .subtract(1, 's')
            .toDate());
        onMounted(() => {
            init();
            events.$on(CART_EVENTS, init);
        });
        onUnmounted(() => {
            events.$off(CART_EVENTS, init);
        });
        watch(() => props.order.shippingMethod.deliverySchemeName, onTargetDateChange);
        function onTargetDateChange() {
            init();
        }
        function init() {
            if (props.order.shippingMethod.deliverySchemeName) {
                selectedDeliveryScheme.value = props.order.shippingMethod.deliverySchemeName;
            }
            loading.value = true;
            loadDeliveryDates();
            // make sure selected date is visible
            if (selectedDate.value && !moment(selectedDate.value).isBetween(moment(minDate.value), moment(maxDate.value))) {
                date.value = selectedDate.value;
            }
        }
        function loadDeliveryDates() {
            cartRepository
                .getShippingOptions(props.order.id, props.order.channel)
                .then(o => {
                options.value = o;
                initDeliveryDates();
            })
                .finally(() => {
                loading.value = false;
            });
        }
        function initDeliveryDates() {
            deliverySlots.value = ((options.value && options.value.deliveryDayOptions) || [])
                .map(delivery => {
                const selected = !!selectedDeliveryScheme.value
                    && delivery.deliverySchemes != null
                    && delivery.deliverySchemes.some(t => t.name === selectedDeliveryScheme.value);
                if (selected) {
                    selectedDate.value = delivery.targetDate;
                }
                return {
                    date: delivery.targetDate,
                    title: moment(delivery.targetDate).format('L'),
                    status: determineSlotStatus(delivery),
                    selected: selected || false,
                    deliveryScheme: (delivery.deliverySchemes && delivery.deliverySchemes.length > 0)
                        ? delivery.deliverySchemes[0].name
                        : undefined,
                };
            });
        }
        function determineSlotStatus(delivery) {
            if (delivery.deliverable === 'NO_DELIVERY') {
                return 'no_delivery';
            }
            if (delivery.deliverable === 'NO_DELIVERY_SCHEMES' || !delivery.deliverySchemes) {
                return 'unavailable';
            }
            return delivery.deliverySchemes.find(s => s.numberOfDeliveries === 1)
                ? 'available'
                : 'available_partial';
        }
        function firstSlotForEvent(event) {
            return deliverySlots.value.find(ds => ds.date == event.date);
        }
        function onDateSelected(slot) {
            if (loading.value) {
                return;
            }
            if (slot.selected || !slot.deliveryScheme) {
                return;
            }
            loading.value = true;
            emit('select-scheme', slot.deliveryScheme);
        }
        function hasSelectedEvent(day) {
            return !!day.events.find((e) => e.selected);
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["cart-delivery-date", { 'cart-delivery-date--none': !__props.order.shippingMethod || !__props.order.shippingMethod.deliverySchemeName }])
            }, [
                (date.value)
                    ? (_openBlock(), _createBlock(WeekCalendar, {
                        key: 0,
                        events: deliverySlots.value,
                        date: date.value,
                        "min-date": minDate.value,
                        "max-date": maxDate.value,
                        class: _normalizeClass({ 'week-calendar--loading': loading.value }),
                        "number-of-weeks": __props.visibleWeeks ?? 2,
                        "highlight-now": false
                    }, {
                        title: _withCtx(() => [
                            _createElementVNode("div", null, [
                                (!__props.order.shippingMethod || !__props.order.shippingMethod.deliverySchemeName)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                                        _createVNode(_component_icon, { name: "exclamation-triangle" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('orders.no_delivery_date')), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        day: _withCtx(({ day }) => [
                            _createElementVNode("div", {
                                class: _normalizeClass(["cart-delivery-date__slots", { 'cart-delivery-date__slots--selected': hasSelectedEvent(day) }])
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.events, (event, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        onClick: _withModifiers(($event) => (onDateSelected(firstSlotForEvent(event))), ["prevent"]),
                                        class: _normalizeClass(["cart-delivery-date__slot", { 'cart-delivery-date__slot--selected': firstSlotForEvent(event).selected,
                                                'cart-delivery-date__slot--available': event.status === 'available',
                                                'cart-delivery-date__slot--available-partial': event.status === 'available_partial',
                                                'cart-delivery-date__slot--unavailable': event.status === 'unavailable',
                                                'cart-delivery-date__slot--no-delivery-day': event.status === 'no_delivery' }])
                                    }, [
                                        _createElementVNode("span", _hoisted_3, [
                                            (firstSlotForEvent(event).selected)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createVNode(_component_icon, {
                                                        name: "check",
                                                        title: _ctx.$t('delivery.delivery_day_selected', { date: event.title })
                                                    }, null, 8, ["title"]),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.$t(event.status === 'available' ? 'delivery.selected' : 'delivery.selected_partial')), 1)
                                                ], 64))
                                                : (event.status === 'no_delivery')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('delivery.no_delivery_day')), 1)
                                                    ], 64))
                                                    : (event.status === 'unavailable')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('delivery.delivery_unavailable')), 1)
                                                        ], 64))
                                                        : (event.status === 'available')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('delivery.delivery_available')), 1)
                                                            ], 64))
                                                            : (event.status === 'available_partial')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('delivery.delivery_available_partial')), 1)
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                        ])
                                    ], 10, _hoisted_2));
                                }), 128))
                            ], 2),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("div", {
                                class: "week-calendar__day-name",
                                title: _ctx.$date(day.date)
                            }, _toDisplayString(_ctx.$date(day.date, 'D. MMM')), 9, _hoisted_4)
                        ]),
                        _: 1
                    }, 8, ["events", "date", "min-date", "max-date", "class", "number-of-weeks"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
